import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Terminal } from '../../../../utils/types/classes/Terminal';

interface TerminalDetailsProps {
    terminal: Terminal;
    onClose?: () => void;
}

const TerminalDetailsContent: React.FC<TerminalDetailsProps> = ({ terminal }) => {
    return (
        <div className="card">
            <div className="card-body">
                <ul>
                    <li>ID: {terminal.id}</li>
                    <li>Android ID: {terminal.androidId ?? 'N/A'}</li>
                    <li>Local UID: {terminal.localUID ?? 'N/A'}</li>
                    <li>ID Point de Vente: {terminal.idPointDeVente ?? 'N/A'}</li>
                    <li>Actif: {terminal.actif != null ? (terminal.actif ? 'Oui' : 'Non') : 'N/A'}</li>
                    <li>Date de Mise en Service: {terminal.dateMiseEnService?.toLocaleString() ?? 'N/A'}</li>
                    <li>Mot de passe Manager: {terminal.pwdManager ?? 'N/A'}</li>
                    <li>Code Manuel: {terminal.codeManuel ?? 'N/A'}</li>
                    <li>Date d'Enregistrement: {terminal.dateEnregistrement?.toLocaleString() ?? 'N/A'}</li>
                </ul>
            </div>
        </div>
    );
};

const TerminalDetails: React.FC<TerminalDetailsProps> = ({ terminal, onClose }) => {
    const [showModal, setShowModal] = useState(false);

    const handleClose = () => {
        setShowModal(false);
        onClose?.();
    };
    const handleShow = () => setShowModal(true);

    return (
        <>
            <button
                onClick={handleShow}
                style={{
                    cursor: 'pointer',
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    color: '#0066cc',
                    textDecoration: 'underline',
                }}
            >
                Détails
            </button>

            <Modal show={showModal} onHide={handleClose} size="lg" scrollable backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Détails du Terminal</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <TerminalDetailsContent terminal={terminal} />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default TerminalDetails;
